import { useEffect, useMemo, useState } from "react";

// ✅ Base real del backend (NO un .php)
const API_BASE = "https://elshowdelasbanqueras.com/show-banqueras-api";

const ENDPOINTS = {
  list: `${API_BASE}/api/job_seekers_list.php`,
  create: `${API_BASE}/api/job_seekers_create.php`,
};

const AREAS = [
  "Digitador o Digitadora",
  "Mensajero",
  "Conserje",
  "Seguridad",
  "Contable",
];

// ✅ Provincias RD (puedes ajustar nombres si lo deseas)
const PROVINCIAS = [
  "Azua",
  "Baoruco",
  "Barahona",
  "Dajabón",
  "Distrito Nacional",
  "Duarte",
  "Elías Piña",
  "El Seibo",
  "Espaillat",
  "Hato Mayor",
  "Hermanas Mirabal",
  "Independencia",
  "La Altagracia",
  "La Romana",
  "La Vega",
  "María Trinidad Sánchez",
  "Monseñor Nouel",
  "Monte Cristi",
  "Monte Plata",
  "Pedernales",
  "Peravia",
  "Puerto Plata",
  "Samaná",
  "San Cristóbal",
  "San José de Ocoa",
  "San Juan",
  "San Pedro de Macorís",
  "Sánchez Ramírez",
  "Santiago",
  "Santiago Rodríguez",
  "Santo Domingo",
  "Valverde",
];

export default function JobSeekerForm() {
  const [form, setForm] = useState({
    nombre: "",
    telefono: "",
    ciudad: "",
    provincia: "",
    area: "",
    perfil: "",
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");

  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const [profiles, setProfiles] = useState([]);
  const [listLoading, setListLoading] = useState(false);

  const canSubmit = useMemo(() => {
    return (
      form.nombre.trim() &&
      form.telefono.trim() &&
      form.ciudad.trim() &&
      form.provincia.trim() &&
      form.area.trim() &&
      form.perfil.trim()
    );
  }, [form]);

  const onChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onPickPhoto = (e) => {
    const file = e.target.files?.[0] || null;
    setPhotoFile(file);

    if (photoPreview) URL.revokeObjectURL(photoPreview);

    if (file) {
      const url = URL.createObjectURL(file);
      setPhotoPreview(url);
    } else {
      setPhotoPreview("");
    }
  };

  const fetchProfiles = async () => {
    setListLoading(true);
    setErr("");
    try {
      const res = await fetch(ENDPOINTS.list);
      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("La API no devolvió JSON. Revisa el endpoint list.php.");
      }

      if (!res.ok) throw new Error(data?.message || "Error cargando listados");
      setProfiles(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e.message || "Error cargando listados");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setOk(false);
    setErr("");

    if (!canSubmit) {
      setErr("Completa todos los campos obligatorios.");
      return;
    }

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("nombre", form.nombre);
      fd.append("telefono", form.telefono);
      fd.append("ciudad", form.ciudad);
      fd.append("provincia", form.provincia); // ✅ NUEVO
      fd.append("area", form.area);
      fd.append("perfil", form.perfil);
      if (photoFile) fd.append("foto", photoFile);

      const res = await fetch(ENDPOINTS.create, {
        method: "POST",
        body: fd,
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("La API no devolvió JSON. Revisa create.php.");
      }

      if (!res.ok) throw new Error(data?.message || "No se pudo guardar.");

      setOk(true);
      setForm({
        nombre: "",
        telefono: "",
        ciudad: "",
        provincia: "",
        area: "",
        perfil: "",
      });
      setPhotoFile(null);

      if (photoPreview) URL.revokeObjectURL(photoPreview);
      setPhotoPreview("");

      await fetchProfiles();
      setTimeout(() => setOk(false), 2500);
    } catch (e2) {
      setErr(e2.message || "Error guardando perfil");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="container">
      <div className="grid grid-2">
        {/* FORM */}
        <form className="card" onSubmit={onSubmit}>
          <h2 style={{ marginTop: 0 }}>¿Buscas empleo?</h2>
          <p className="p">Completa tus datos para publicar tu perfil en la parrilla.</p>

          {/* Foto */}
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <div
              className="card"
              style={{
                width: 92,
                height: 92,
                borderRadius: 18,
                padding: 0,
                overflow: "hidden",
                display: "grid",
                placeItems: "center",
                background: "rgba(255,255,255,.06)",
              }}
            >
              {photoPreview ? (
                <img
                  src={photoPreview}
                  alt="preview"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <span style={{ opacity: 0.7 }}>Foto</span>
              )}
            </div>

            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontWeight: 800, marginBottom: 6 }}>
                Foto (opcional)
              </label>
              <input type="file" accept="image/*" onChange={onPickPhoto} />
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
                JPG/PNG recomendado. Se guardará en el servidor.
              </div>
            </div>
          </div>

          <div style={{ height: 12 }} />

          <input
            className="card"
            style={{ width: "100%", padding: 12 }}
            placeholder="Nombre"
            name="nombre"
            value={form.nombre}
            onChange={onChange}
            required
          />
          <div style={{ height: 10 }} />

          <input
            className="card"
            style={{ width: "100%", padding: 12 }}
            placeholder="Teléfono (no se publica)"
            name="telefono"
            value={form.telefono}
            onChange={onChange}
            required
          />
          <div style={{ height: 10 }} />

          <input
            className="card"
            style={{ width: "100%", padding: 12 }}
            placeholder="Ciudad"
            name="ciudad"
            value={form.ciudad}
            onChange={onChange}
            required
          />
          <div style={{ height: 10 }} />

          {/* Provincia */}
          <label style={{ display: "block", fontWeight: 900, marginBottom: 6 }}>
            Provincia
          </label>
          <select
            className="card"
            style={{ width: "100%", padding: 12 }}
            name="provincia"
            value={form.provincia}
            onChange={onChange}
            required
          >
            <option value="">Seleccione una provincia…</option>
            {PROVINCIAS.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>

          <div style={{ height: 10 }} />

          {/* Área */}
          <label style={{ display: "block", fontWeight: 900, marginBottom: 6 }}>
            Área en la que tiene experiencia
          </label>

          <select
            className="card"
            style={{ width: "100%", padding: 12 }}
            name="area"
            value={form.area}
            onChange={onChange}
            required
          >
            <option value="">Seleccione un área…</option>
            {AREAS.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>

          <div style={{ height: 10 }} />

          <textarea
            className="card"
            style={{ width: "100%", padding: 12, minHeight: 120 }}
            placeholder="Describe tu experiencia / servicios"
            name="perfil"
            value={form.perfil}
            onChange={onChange}
            required
          />

          <div style={{ height: 12 }} />

          <button
            className="btn btn-blue"
            type="submit"
            disabled={loading}
            style={{ width: "100%", justifyContent: "center", opacity: loading ? 0.7 : 1 }}
          >
            {loading ? "Guardando..." : "Publicar perfil"}
          </button>

          {err && <div style={{ marginTop: 12, color: "#ff7b7b" }}>❌ {err}</div>}
          {ok && <div style={{ marginTop: 12, color: "var(--green)" }}>✅ Perfil enviado</div>}
        </form>

        {/* LISTVIEW */}
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
            <h2 style={{ margin: 0 }}>Perfiles publicados</h2>
            <button className="btn btn-ghost" onClick={fetchProfiles} disabled={listLoading}>
              {listLoading ? "Actualizando..." : "Actualizar"}
            </button>
          </div>

          <p className="p" style={{ marginTop: 8 }}>
            Listado de perfiles.
          </p>

          {listLoading ? (
            <div style={{ opacity: 0.7 }}>Cargando...</div>
          ) : profiles.length === 0 ? (
            <div style={{ opacity: 0.7 }}>No hay perfiles aún.</div>
          ) : (
            <div style={{ display: "grid", gap: 12 }}>
              {profiles.map((p) => {
                const fotoPath = (p.foto_url || "").replace(/^\/+/, "");
                return (
                  <div key={p.id} className="card" style={{ padding: 12, borderRadius: 16 }}>
                    <div style={{ display: "flex", gap: 12 }}>
                      <div
                        style={{
                          width: 70,
                          height: 70,
                          borderRadius: 16,
                          overflow: "hidden",
                          background: "rgba(255,255,255,.06)",
                          flexShrink: 0,
                          display: "grid",
                          placeItems: "center",
                        }}
                      >
                        {fotoPath ? (
                          <img
                            src={`${API_BASE}/${fotoPath}`}
                            alt={p.nombre}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        ) : (
                          <span style={{ opacity: 0.7 }}>Sin foto</span>
                        )}
                      </div>

                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 900 }}>
                          {p.nombre} <span style={{ color: "var(--gold)" }}>• {p.area}</span>
                        </div>

                        <div style={{ fontSize: 13, opacity: 0.8 }}>
                          📍 {p.ciudad} • {p.provincia ? `🏛️ ${p.provincia}` : ""}
                        </div>

                        {/* ✅ Teléfono oculto por seguridad (si lo quieres mostrar aquí, me dices) */}
                        <div style={{ marginTop: 6, opacity: 0.9, lineHeight: 1.45 }}>
                          {p.perfil}
                        </div>

                        <div style={{ fontSize: 12, opacity: 0.6, marginTop: 6 }}>
                          {p.created_at}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
